<div class="mat-dialog-container-in">
  <div class="dialog-box create-dialog-box">
    <div *ngIf="icon_class" class="dialog-icon {{icon_class}} {{marRight}}"></div>
    <div class="dialog-content">
      <h1 class="custom-h1" *ngIf="!warningDialog">{{text}}</h1>
      <div *ngIf="warningDialog" mat-dialog-content>
        <div  class="mat-dialog-content" [innerHtml]="warningDialog"></div>
      </div>
      <div>
        <button class="ok" mat-dialog-close>OK</button>
      </div>
    </div>
  </div>
</div>

